import styled from "styled-components";
import ChevronUp from "src/design-system/icons/ChevronUp.svg?react";
import { iconSize } from "src/design-system/tokens/iconSize";
import color from "src/design-system/tokens/color";

const rotateDirection = {
  up: "0deg",
  right: "90deg",
  down: "180deg",
  left: "270deg",
} as const;

type RotatingChevronProps = {
  direction: keyof typeof rotateDirection;
  size?: keyof typeof iconSize;
  color?: string;
  title?: string;
};

export function RotatingChevron(props: RotatingChevronProps) {
  return (
    <StyledChevron
      width={props.size ?? iconSize.sm}
      height={props.size ?? iconSize.sm}
      color={props.color ?? color.icon.primary}
      title={props.title}
      {...props}
    />
  );
}

const StyledChevron = styled(ChevronUp)<{
  direction: keyof typeof rotateDirection;
}>`
  transition: transform 0.3s ease;
  transform: rotate(${(props) => rotateDirection[props.direction]});
`;
